import * as React from 'react';
import { useState } from 'react';
import Box from "@material-ui/core/Box";
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import { setSolicitud } from "../../redux/actions/solicitudActions";
import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { ITipoEnvio } from "../../entities/catalogos/ITipoEnvio";
import AyudaDialog from "../controls/AyudaDialog";
import { ISolicitud } from "../../entities/solicitudes/Solicitud";
import { IHelp } from '../help/Help';
import { traducirButton, traducirLabel, traducirMessage } from '../../blocks/traductor';



const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        iconCustomMaterial: {
            fontSize: 30
        },
        iconCustom: {
            width: "70px",
            height: "70px"
        },
        iconCustomDefault: {
            width: "90px",
            height: "40px"
        },
        selected: {
            color: "#fff !important",
            backgroundColor: "#006939 !important"
        },
        linkText: {
            color: "#00653b !important",
        },
        linkSelected: {
            color: "#fff !important",
        }
    })
);

interface OwnProps {
    tipoEnvio: ITipoEnvio
    seleccionado: boolean
    onSelect: (tipoEnvio: ITipoEnvio) => void
    icono: string
}

interface StateProps {
    cotizacion: ISolicitud
    ayuda: IHelp
}

interface DispatchProps {
    setCotizacion: typeof setSolicitud
}

type Props = OwnProps & StateProps & DispatchProps

//Cambiar el mensaje por el id de la traducción cuando se tenga
const tipoEnvioMensajesIds = [
    { id: 1, nombre: "servicioAlmex" },
    {
        id: 2, nombre: "AlmexPriority",
        msgId: traducirMessage(280) // "Tu carga viaja con prioridad"
    },
    {
        id: 3, nombre: "AlmexProximity",
        msgId: traducirMessage(279) // "Tu carga regional llega a tiempo"
    },
    {
        id: 4, nombre: "AlmexOne",
        msgId: traducirMessage(278) // "Tu carga llega al día siguiente"
    },
]

const TipoEnvio = ({ tipoEnvio, seleccionado, onSelect, ayuda, icono }: Props) => {
    const [ayudaAbierta, setAyudaAbierta] = useState(false);
    const abrirAyuda = () => {
        setAyudaAbierta(true);
    };
    const classes = useStyles();
    const cerrarAyuda = () => {
        setAyudaAbierta(false);
    };


    const nombreIconoDisplay = icono;


    const detalleTipoEnvio = (tipoEnvio) => {
        switch (tipoEnvio) {
            case 'SERVICIO ALMEX':
                return traducirMessage(261);
            case 'ALMEX PRIORITY':
                return traducirMessage(188);
            case 'ALMEX PROXIMITY':
                return traducirMessage(189);
            case 'ALMEX ONE':
                return traducirMessage(163);
            default:
                return '';
        }
    };

    const getMensajeDetalle = (tipoEnvioId) => {
        const tipoEnvioMensaje = tipoEnvioMensajesIds.find(e => e.id === tipoEnvio.id);

        if (tipoEnvioMensaje?.msgId == null) return "";

        let msg = '';
        if (tipoEnvioMensaje?.id === 2)
            msg = traducirMessage(280);

        if (tipoEnvioMensaje?.id === 3)
            msg = traducirMessage(279);

        if (tipoEnvioMensaje?.id === 4)
            msg = traducirMessage(278);
        // return traducirMessage(tipoEnvioMensaje.msgId); Descomentar cuando se tenga la traducción y quitar la linea de abajo
        return msg;
    }

    return (<>
        <Grid item>
            <Box className={`pointer card medium-height ${seleccionado ? classes.selected : ''}`}
                style={{ padding: "10px 10px", width: "160px", height: "210px" }}
                display="flex" flexDirection="column">
                <Box className={`title-3 ${seleccionado ? "white-label text-center" : 'green-label text-center'}`}
                    onClick={() => onSelect(tipoEnvio)}>
                    <b>{tipoEnvio.nombre}</b>
                </Box>

                <Box className="title-4 text-center" display="flex" alignItems="center" justifyContent="center" py={1}
                    onClick={() => onSelect(tipoEnvio)} style={{ height: "138px" }}>
                    <img src={"/image/tiposEnvio/" + nombreIconoDisplay} alt="icon"
                        className={tipoEnvio.id == 1 && !seleccionado ? classes.iconCustomDefault : classes.iconCustom} />
                </Box>

                <Box className={`title-4 text-center ${seleccionado ? "white-label" : 'green-label'}`}
                    style={{ textTransform: "uppercase", fontWeight: "bold" }} onClick={() => onSelect(tipoEnvio)}>
                    {getMensajeDetalle(tipoEnvio.id)}
                </Box>

                <Box className="title-4 text-center" pt={1}>
                    <Button className={`link-md title-4 ${seleccionado ? classes.linkSelected : classes.linkText}`}
                        onClick={abrirAyuda}>
                        {/* Ver más detalle */traducirLabel(316)}
                    </Button>
                </Box>
            </Box>
        </Grid>

        <AyudaDialog titulo={tipoEnvio.nombre} contenido={detalleTipoEnvio(tipoEnvio.nombre)} abierto={ayudaAbierta}
            cerrar={cerrarAyuda} />
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    cotizacion: state.solicitud,
    ayuda: state.ayuda
});

const mapDispatchToProps = {
    setCotizacion: setSolicitud
};

export default connect(mapStateToProps, mapDispatchToProps)(TipoEnvio);
